module.exports = __webpack_public_path__ + "img/loader.d2668e02.gif";